import { useCallback } from 'react';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import styles from './withIconButton.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export type IconButtonComponentProps<T> = {
  icon: IconDefinition;
  iconClass?: string;
  buttonTooltip?: {
    id: string;
    tooltip: string;
  };
  onButtonClick: () => void;
} & T;

export function withIconButton<T>(
  WrapperComponent: React.FC<T>
): React.FC<IconButtonComponentProps<T>> {
  const IconButtonComponent: React.FC<IconButtonComponentProps<T>> = (
    props
  ) => {
    const { icon, iconClass, buttonTooltip, onButtonClick, ...restProps } =
      props;

    const renderButton = useCallback(() => {
      const iconClassName = cx(styles.iconButton, iconClass);
      return (
        <div className={styles.iconContainer}>
          <IconWithTooltip
            className={iconClassName}
            onClick={onButtonClick}
            icon={icon}
            tooltipProps={buttonTooltip}
          />
        </div>
      );
    }, [icon, iconClass, buttonTooltip, onButtonClick]);

    return (
      <div className={styles.container}>
        <WrapperComponent {...(restProps as T & JSX.IntrinsicAttributes)} />
        {renderButton()}
      </div>
    );
  };

  return IconButtonComponent;
}
